import type { FaireProductEntity } from "../../entity_types/product";

export const p_42ikykw0am: FaireProductEntity = {
  token: "p_42ikykw0am",
  type: "product",
  name: "MULHOLLAND",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/52ff2fbffbf40b77f1d6fb87417e55cc41ddc8c7da40e83b36ff5b347188e9db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67fbc1fe9eed1c1fbd92b69bfe0e318f01a9da3d6195f85ee3bd98588e9ad016.jpeg",
    "https://cdn.faire.com/fastly/674dcfa7fbe1961cfd2c713f2de05a7e9a7f3f92a4baab59a30853068771e26d.jpeg"
  ],
  priceDollars: 18,
  description: "A rich but sophisticated fragrance that intertwines the alluring scent of hinoki wood with creamy notes of amber resin and suede. Nuances of clove bud, incense and spice unfurl to give this opulent scent a layer of warmth and complexity.\n\nhinoki wood, amber resin, suede, incense, clove bud\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:06.503Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
